import { getInstance } from "./authWrapper";
import { fetchOrg } from "@/global";

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = () => {
    if (authService.isAuthenticated) {
      if (authService.user.email_verified) {
        fetchOrg();
        return next();
      } else {
        return next("/verify-email");
      }
    }

    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  if (!authService.loading) {
    return fn();
  }

  authService.$watch("loading", loading => {
    if (loading === false) {
      return fn();
    }
  });
};
